import { useMemo } from 'react';
import { DynamicRating } from 'atoms/Rating/DynamicRating';
import { Body } from 'atoms/Typography/Typography';
import { FilterItem } from 'organisms/Filters/FilterItem';
import { useFilters } from 'organisms/Filters/hooks';
import { useTranslations } from 'modules/i18n/useTranslations';
import { Facets } from 'commerce/factFinder/types';
import styles from './styles.module.css';

export const Reviews = () => {
  const t = useTranslations();
  const { filters, setFilters, addSingleFilter } = useFilters();

  const onChange = (_: unknown, value: number | null) => {
    if (!value) {
      setFilters((filters) =>
        filters.filter(({ type }) => type !== Facets.RATING),
      );
    } else {
      addSingleFilter({
        type: Facets.RATING,
        value: [value || 0],
        displayValue: t('search.filters.ratingChip', {
          value,
        }),
      });
    }
  };

  const ratingFilter = useMemo(
    () =>
      filters.find(({ type }) => type === Facets.RATING)?.value?.[0] as number,
    [filters],
  );

  return (
    <FilterItem>
      <Body tag="span" type="md">
        {t('search.filters.rating')}
      </Body>
      <DynamicRating
        className={styles.rating}
        value={ratingFilter || 0}
        size="large"
        onChange={onChange}
      />
    </FilterItem>
  );
};
